<div class="household-filter-container" [class.compact]="compact">
  <label *ngIf="!compact">Filter by Household</label>

  <!-- Searchable dropdown trigger button -->
  <button
    class="household-filter-trigger"
    (click)="toggleDropdown()"
    [class.open]="is_dropdown_open"
    data-testid="household-filter-trigger"
    type="button">
    <span class="selected-value">{{ getSelectedHouseholdDisplayName() }}</span>
    <svg
      class="dropdown-arrow"
      [class.rotate]="is_dropdown_open"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  </button>

  <!-- Dropdown panel -->
  <div
    class="household-dropdown-panel"
    *ngIf="is_dropdown_open"
    data-testid="household-dropdown-panel">

    <!-- Search input -->
    <div class="dropdown-search-container">
      <svg
        class="search-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.35-4.35"></path>
      </svg>
      <input
        type="text"
        class="dropdown-search-input"
        placeholder="Search households..."
        [ngModel]="search_query"
        (ngModelChange)="onSearchChange($event)"
        (click)="onSearchInputClick($event)"
        data-testid="household-search-input"
        autofocus>
    </div>

    <!-- Loading state -->
    <div *ngIf="is_loading_households" class="dropdown-loading">
      <span>Loading households...</span>
    </div>

    <!-- Dropdown options -->
    <div class="dropdown-options" *ngIf="!is_loading_households">
      <!-- All Households option -->
      <div
        class="dropdown-option"
        [class.selected]="selected_household_id === null"
        (click)="selectHousehold(null)"
        data-testid="household-option-all">
        <span>All Households</span>
        <svg
          *ngIf="selected_household_id === null"
          class="check-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>

      <!-- Household options -->
      <div
        *ngFor="let household of households"
        class="dropdown-option"
        [class.selected]="selected_household_id === household.HOUSEHOLD_ID"
        (click)="selectHousehold(household.HOUSEHOLD_ID)"
        [attr.data-testid]="'household-option-' + household.HOUSEHOLD_ID">
        <span>{{ household.HOUSEHOLD_NAME }}</span>
        <svg
          *ngIf="selected_household_id === household.HOUSEHOLD_ID"
          class="check-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>

      <!-- Empty state -->
      <div
        *ngIf="households.length === 0"
        class="dropdown-empty"
        data-testid="household-dropdown-empty">
        <span>No households found</span>
      </div>
    </div>
  </div>
</div>
